export default __webpack_public_path__ + "static/media/product-01 (2).c1474aae.jpg";